/**
 * NF-962: Controller for managing notifications.
 */

/**
 * @class ReleaseChargingPointController
 * Initializes a new instance of the ReleaseChargingPointController.
 */
function ReleaseChargingPointController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
ReleaseChargingPointController.$inject = ['$rootScope', 'NotificationService', '$message', '$Loading', '$q'];


// Define the prototype methods for NotificationsCtrl
ReleaseChargingPointController.prototype = {
    /**
     * @type {NotificationModel} notification
     */
    notification: {},

    isNotificationOnNotificationsModule: false,
    /**
     * Initializes the controller with necessary services and scope.
     * @param {angular.IRootScopeService} $rootScope
     * @param {NotificationService} NotificationService
     * @param {$message} $message
     * @param {$Loading} $Loading
     * @param {ng.IQService} $q
     */
    init: function ($rootScope, NotificationService, $message, $Loading, $q) {
        this.$rootScope = $rootScope;
        this.notificationService = NotificationService;
        this.$message = $message;
        this.$Loading = $Loading;
        this.$q = $q;
    },


    snooze: function (delay) {
        this.notificationService.snoozeNotification(this.notification, delay)
            .then(() => {
                this.close();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },


    /**
     * Mark a charging point as free and mark notification as read
     */
    markAsFree: function () {
        // Call the service to mark the charging point as free
        this.notificationService.markChargingPointAsFree(this.notification.Id)
            .then(() => {
                this.$rootScope.$broadcast('refresh-home-data');
                this.close();
            }, this.$message.error) // Handle error for marking charging point as free
            .finally(this.$Loading.blockUI());
    }

};


// Register the ChargeHasEndedController controller with the AngularJS module
angular.module('internal.notifications').controller('ReleaseChargingPointController', ReleaseChargingPointController);